import { Component } from "@angular/core";

@Component({
  selector: "app-one-column",
  templateUrl: "./one-column.component.html",
  styleUrls: ["one-column.component.scss"],
})
export class OneColumnComponent {}
